export default __webpack_public_path__ + "static/media/icon-home-add.8a1e636a.svg";